import { useState } from "react";
import deliveryServiceTypes from "../../../constants/deliveryServiceTypes";
import useStore from "../../../hooks/useStore";
import OnboardingForm from "./OnboardingForm";
import UberEatsOnboarding from "./UberEatsOnboarding";
import UberEatsOnboardingOptions from "./UberEatsOnboardingOptions";
import DeliverySettings from "../deliverySettings/DeliverySettings";
import UberEatsDisconnect from "./ubereatsDisconnect/UberEatsDisconnect";
import { getUberEatsOAuth2Link } from "../../apiRepository/Ubereats";

export default function UberEatsDS() {
  const { store } = useStore();
  const deliverySetting = store?.deliverySettings?.uberEats;

  const [isLoading, setIsLoading] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const [hasExistingAccount, setHasExistingAccount] = useState(false);
  const [snackbar, setSnackbar] = useState({
    severity: "error",
    message: "",
    open: false,
  });

  const handleBack = () => {
    setIsLoading(false);
    setShowOptions(false);
    setShowForm(false);
  };

  const handleShowOptions = () => {
    setIsLoading(false);
    setShowOptions(true);
    setShowForm(false);
  };

  const handleCloseSnackbar = (_event, _reason) => {
    setSnackbar((prev) => ({ ...prev, open: false, message: null }));
  };

  const handleProvision = async (action) => {
    try {
      setIsLoading(true);
      const { oauth_link } = await getUberEatsOAuth2Link({
        integratorId: store.integratorId,
        storeId: store.storeId,
        redirectUri: `${process.env.REACT_APP_UBER_REDIRECT_URI}?provision_type=${action}`,
        token: store.token
      });
      setIsLoading(false);
      window.open(oauth_link, "_self");
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      setSnackbar({ open: true, message: error, severity: "error" });
    }
  };

  if (
    (!deliverySetting || Object.keys(deliverySetting).length === 0) &&
    !showForm &&
    !showOptions
  ) {
    return (
      <UberEatsOnboarding handleShowOptions={handleShowOptions} />
    );
  }

  if (
    (!deliverySetting || Object.keys(deliverySetting).length === 0) &&
    !showForm &&
    showOptions
  ) {
    return (<UberEatsOnboardingOptions
      isLoading={isLoading}
      handleBack={handleBack}
      handleProvision={handleProvision}
      snackbar={snackbar}
      handleCloseSnackbar={handleCloseSnackbar}
    />);
  }

  if (
    (!deliverySetting || Object.keys(deliverySetting).length === 0) &&
    showForm
  ) {
    return (
      <OnboardingForm
        closeForm={() => setShowForm(false)}
        deliveryService={deliveryServiceTypes.uberEats.capitalize}
        hasExistingAccount={hasExistingAccount}
      />
    );
  }

  return (
    <>
      <DeliverySettings deliveryService={deliveryServiceTypes.uberEats.cammel} />
      <UberEatsDisconnect
        isLoading={isLoading}
        handleProvision={handleProvision}
      />
    </>
  );
}
